import { DataBean } from "../DataBean";

export class PayrollSheets extends DataBean {



    public async getElectronicPayrollSheets(args:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getElectronicPayrollSheets_Number", [args]);
    }
    
}